/* import __COLOCATED_TEMPLATE__ from './open-conversation.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();